import React, { useEffect, useRef, useState } from 'react';
import Styles from './ModalTerms.css';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import clsx from 'clsx';
import { useGetTerms } from '../../api/use-get-terms';
import Button from '../../widgets/Button/Button';
import { getErrorMessage } from '../../shared/utils/error';

function ModalTerms() {
  const [readTerms, setReadTerms] = useState(false);
  const { modalTermsOpen, setModalTermsOpen } = useSimuladorEnergiaSolarState();
  const { data, isFetching, error, failureReason } = useGetTerms({ enabled: modalTermsOpen });

  /** @type {React.MutableRefObject<HTMLDivElement>} */
  const ref = useRef(null);

  const closeModal = () => {
    if (ref.current) {
      ref.current.scrollTop = 0;
    }

    setTimeout(() => {
      setModalTermsOpen(false);
    }, 10);
  };

  useEffect(() => {
    if (!data) {
      setReadTerms(false);
      return;
    }

    if (readTerms && !modalTermsOpen) {
      setReadTerms(false);
    }
  }, [readTerms, modalTermsOpen, data]);

  if (!modalTermsOpen) return null;

  return (
    <>
      <div
        id="modal-terms"
        aria-modal="true"
        className={clsx('modal-termos', modalTermsOpen && 'open')}
      >
        <span className="overlay" />

        <div className="frame">
          <div className="content">
            <Button id="btn-close-terms" variant="flat" onClick={closeModal}>
              <img
                src="assets/simulador-energia-solar/landing/ic-close-modal-terms.svg"
                alt="fechar"
              />
            </Button>
            <p className="modal-title">Termos e Condições de uso e Política de privacidade</p>
            <div
              ref={ref}
              className="modal-body"
              onScroll={(e) => {
                const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
                if (scrollTop + clientHeight >= scrollHeight) {
                  setReadTerms(true);
                }
              }}
            >
              {isFetching ? (
                <>
                  <img
                    className="loading-indicator"
                    src="assets/rastreadores/loader.gif"
                    alt="Loading"
                  />
                </>
              ) : (
                <>
                  <p className="text-row-header">Declarações e autorizações</p>

                  {!!data ? (
                    <div
                      className="render-terms"
                      dangerouslySetInnerHTML={{
                        __html: data.description,
                      }}
                    />
                  ) : (
                    <div className="render-terms">
                      <p className="text-row-header">{getErrorMessage(error || failureReason)}</p>
                    </div>
                  )}
                </>
              )}
            </div>
            {!isFetching && (
              <Button
                loading={isFetching}
                disabled={isFetching || !readTerms}
                centered
                variant="red"
                id="btn-accept-terms"
                onClick={closeModal}
                maxWidth={328}
              >
                Entendi
              </Button>
            )}
          </div>
        </div>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

export default ModalTerms;
